// Abandoned booking recovery system

export interface AbandonedBooking {
  id: string;
  step: 'form' | 'payment';
  formData: {
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    specialRequests?: string;
  };
  bookingDetails: any;
  bookingType: string;
  savedAt: string;
  recovered: boolean;
}

const STORAGE_KEY = 'dff_abandoned_bookings';
const EXPIRY_HOURS = 24;

export function saveAbandonedBooking(data: Omit<AbandonedBooking, 'id' | 'savedAt' | 'recovered'>): string {
  if (typeof window === 'undefined') return '';
  const id = `ab_${Date.now()}`;
  const bookings: AbandonedBooking[] = getAbandonedBookings();
  const newBooking: AbandonedBooking = {
    ...data,
    id,
    savedAt: new Date().toISOString(),
    recovered: false,
  };
  // Replace existing incomplete booking for same session
  const filtered = bookings.filter(b => b.recovered);
  filtered.unshift(newBooking);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered.slice(0, 10)));
  return id;
}

export function getAbandonedBookings(): AbandonedBooking[] {
  if (typeof window === 'undefined') return [];
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return [];
  const bookings: AbandonedBooking[] = JSON.parse(raw);
  // Filter out expired (older than 24h)
  const cutoff = Date.now() - EXPIRY_HOURS * 60 * 60 * 1000;
  return bookings.filter(b => new Date(b.savedAt).getTime() > cutoff);
}

export function getLatestAbandonedBooking(): AbandonedBooking | null {
  const bookings = getAbandonedBookings();
  const unrecovered = bookings.filter(b => !b.recovered);
  return unrecovered[0] || null;
}

export function markBookingRecovered(id: string): void {
  if (typeof window === 'undefined') return;
  const bookings = getAbandonedBookings().map(b =>
    b.id === id ? { ...b, recovered: true } : b
  );
  localStorage.setItem(STORAGE_KEY, JSON.stringify(bookings));
}

export function clearAbandonedBooking(id: string): void {
  if (typeof window === 'undefined') return;
  const bookings = getAbandonedBookings().filter(b => b.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(bookings));
}
